import store from "../store";

export const isSuperAdmin = () => {
  const isSuperAdmin = store.getState().auth?.login?.is_super_admin;
  return isSuperAdmin;
};
